import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import Icon from "@material-ui/core/Icon";
import classNames from "classnames";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddCircle from "@material-ui/icons/AddCircle";

class LoadingIconButtonComponent extends Component {
  render() {
    const {
      working,
      disabled,
      classes,
      color,
      children,
      buttonclicked,
      type,
      ...other
    } = this.props;
    return (
      <button
        type={type || "button"}
        className={classNames(
          classes.button,
          classes.wrapper,
          this.props.mergeclasses
        )}
      >
        {!working && (
          <Icon
            className={classes.icon}
            color={color || "primary"}
            onClick={buttonclicked}
            {...other}
            children={children || <AddCircle />}
          />
        )}
        {working && <CircularProgress className={classes.progress} size={24} />}
      </button>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  LoadingIconButtonComponent
);
